import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitBackpainLevelPage } from './init-backpain-level';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitBackpainLevelPage,
  ],
  imports: [
    IonicPageModule.forChild(InitBackpainLevelPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitBackpainLevelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-backpain-level/init-backpain-level.module.ts